import React, { useContext, useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AppData } from "../../../context/context";
import styles from "./components.module.scss";
import { BorderColorOutlined } from "@material-ui/icons";
import { Link } from "react-router-dom";

const Header = ({
  uniqueKey = "",
  title = "",
  helperText = "",
  linkBack = "",
  isLoading = false,
  setIsLoading,
  setIsNotEditable,
}) => {
  const { formMode, setJobConfigMode, jobConfigMode, userAction } =
    useContext(AppData);

  /* Other states */

  const [mode, setMode] = useState("");

  /* UseEffects */

  useEffect(() => {
    setIsLoading(true);
    if (uniqueKey === "jobConfig") {
      setMode(jobConfigMode);
    } else {
      setMode(formMode);
    }
    setIsLoading(false);
  }, [uniqueKey, jobConfigMode, formMode]);

  return !isLoading ? (
    <>
      <Grid
        item
        xs={uniqueKey === "jobConfig" ? 6 : 12}
        className="flexDisplay"
      >
        <Link to={linkBack}>
          <ArrowBackIcon
            sx={{
              color: "black",
              fontSize: "40",
              cursor: "pointer",
            }}
          ></ArrowBackIcon>
        </Link>
        <span className={styles.formHeading}>
          <h2>{title}</h2>
          <p>{helperText}</p>
        </span>
      </Grid>
      {uniqueKey === "jobConfig" && mode === "view" && !!userAction.edit && (
        <Grid
          item
          xs={6}
          className="flexDisplay"
          style={{
            flexDirection: "row-reverse",
          }}
        >
          <Button
            className={styles.editBtn}
            variant="contained"
            onClick={() => {
              setJobConfigMode("edit");
              setIsNotEditable(true);
            }}
          >
            <BorderColorOutlined
              style={{ height: "15px", width: "20px" }}
            ></BorderColorOutlined>
            <span style={{ marginLeft: "7px" }}>Edit</span>
          </Button>
        </Grid>
      )}
    </>
  ) : null;
};

export default Header;
